import Logo from "../../../assets/img/Logo.svg";
import { Nav } from "./Nav";
import { HeaderContent } from "./style";
export const Header = () => {
  return (
    <HeaderContent>
      <div>
        <img src={Logo} alt="" />
        <Nav />
      </div>
    </HeaderContent>
  );
};
